<script setup>
defineProps({
  disclaimer: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="disclaimer-block">
    <div class="disclaimer-block__inner">
      <div v-if="disclaimer.title" class="disclaimer-block__title">
        {{ disclaimer.title }}
      </div>
      <div class="disclaimer-block__desc">
        <PostContent :content="disclaimer.text" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.disclaimer-block {
  max-width: var(--content-max-width);
  color: var(--title-dark-color);
  padding: 40px 60px 0;
  margin: 0 auto;
  font-size: var(--body-font-size);
  line-height: var(--body-line-height);

  &__inner {
    position: relative;
    z-index: 1;
    padding: 24px;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 50%;
      width: 100%;
      height: 100%;
      transform: translateX(-50%);
      border-radius: 24px;
      background: var(--disclaimer-color);
      opacity: 0.6;
    }
  }

  &__title {
    font-weight: 700;
  }

  &__desc {
    margin: 8px 0 16px 0;
    position: relative;
  }

  @media (--small-vp) {
    padding: 16px;

    &__inner {
      padding: 12px;

      &::before {
        border-radius: 16px;
      }
    }

    &__title {
      font-size: 16px;
      line-height: 20px;
    }

    &__desc {
      font-size: 16px;
      line-height: 22px;
      margin: 4px 0 8px;
    }
  }
}
</style>
